import { Button, Grid } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import RestoreIcon from "@mui/icons-material/Restore";
import { find, isEqual, uniq } from "lodash";
import React, { useContext } from "react";
import { map } from "lodash/fp";
import { EquipmentsFiltersType } from ".";
import { useQuery } from "@apollo/client/react";
import FilterAutocomplete from "@/components/FilterAutocomplete";
import CurrentUserContext from "@/Contexts/CurrentUser";
import { ResourceCategory, GetResourceCategoriesDocument } from "@/graphql/generated/graphql";

interface EquipmentFiltersProps {
  filters: EquipmentsFiltersType;
  onChange: <K extends keyof EquipmentsFiltersType>(key: K, value: EquipmentsFiltersType[K]) => void;
  onReset: () => void;
  disableReset: boolean;
}

const mapCategories = map((item: Pick<ResourceCategory, "id" | "name">) => ({ id: item.id, name: item.name }))

const EquipmentFilters: React.FC<EquipmentFiltersProps> = ({
  filters,
  onChange,
  onReset,
  disableReset,
}) => {
  const { currentUser } = useContext(CurrentUserContext);

  const { data: resCatData } = useQuery(GetResourceCategoriesDocument, {
    variables: { companyId: currentUser?.defaultCompany?.id as string },
  });

  return (
    <Grid container alignItems="center" flexWrap="nowrap" sx={{ my: 1 }} size={12}>
      <FilterAutocomplete
        id="resource-category-id"
        fullWidth
        autoHighlight
        options={uniq(mapCategories(resCatData?.getResourceCategories))}
        getOptionLabel={(option) => option.name || ""}
        value={find((resCatData?.getResourceCategories || []), { id: filters.resourceCategoryId }) || null}
        onChange={(_, value) => onChange("resourceCategoryId", value?.id as string)}
        isOptionEqualToValue={(option, value) => {
          return isEqual(option, value)
        }}
        textFieldLabel={
          <Grid container alignItems="center">
            <CategoryIcon fontSize="small" /> &nbsp; Category
          </Grid>
        }
        sx={{ mr: 1 }}
      />
      <Button
        size="small"
        variant="outlined"
        onClick={onReset}
        startIcon={<RestoreIcon />}
        disabled={disableReset}
        sx={{ px: 10 }}
      >
        Reset
      </Button>
    </Grid>
  )
}

export default EquipmentFilters;
